import { useIntl } from "react-intl";
import { ITabsData } from "../../DynamicTabs/DynamicTabs";
import { DynamicTabs, SimpleModal } from "src/app/components";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { SimpleFormTextarea } from "../../form/SimpleFormTextarea";
import { useField } from "formik";
import { getKeywordFromString } from "src/app/utils/keywordsHelper";
import { findIndex } from "lodash";
import { Planning } from "src/app/types/planning";
import { SimpleFormSelectOption } from "../../form/SimpleFormSelect";
import { RDListByThematicIdContainer } from "src/app/containers";

export interface INetlinkingOrderForm {
    planning: Planning;
    thematicsOptions: SimpleFormSelectOption[];
}
const NetlinkingOrderForm: React.FC<INetlinkingOrderForm> = (props: INetlinkingOrderForm) => {
    const { planning, thematicsOptions } = props;
    const thematic = planning.moneySite.thematic;
    const { formatMessage } = useIntl();
    const [kwNetlinkingInput, , kwNetlinkingHelper] = useField("kwNetlinking");
    const [tabs, setTabs] = useState<Array<ITabsData>>([
        { name: `${thematic.name} (0)`, index: thematic.id },
    ]);
    const [showModal, setShowModal] = useState(false);
    const [seleted, setSeleted] = useState({ name: thematic.name, index: thematic.id });

    const handleModal = () => {
        setShowModal((el) => !el);
    };
    const onAdd = ({ name, index }: ITabsData) => {
        setTabs((values) => {
            const valueIndex = values.findIndex((el) => el.index === index);
            if (valueIndex === -1) {
                return [...values, { name: `${name} (0)`, index }];
            }
            return values;
        });
        setSeleted({ name, index });
    };

    const onSelect = ({ name, index }: ITabsData) => {
        setSeleted({
            name,
            index,
        });
    };
    const onDelete = (tab: ITabsData, index: number) => {
        setTabs((values) => [...values.filter((el) => el.index !== tab.index)]);
        if (seleted.index === tab.index) {
            onSelect(tabs[index - 1]);
        }
        const values: { [key: string]: string } = kwNetlinkingInput.value;
        const { [`thematicId${tab.index}`]: toRemove, ...currentValues } = values;
        kwNetlinkingHelper.setValue(currentValues);
    };

    useEffect(() => {
        const currentField = `thematicId${seleted.index}`;
        if (
            !kwNetlinkingInput?.value ||
            !Object.keys(kwNetlinkingInput?.value).includes(currentField)
        )
            return;

        const wordCount = getKeywordFromString(kwNetlinkingInput.value[currentField]).length;
        const indexOfTab = findIndex(tabs, (el) => el.index === seleted.index);
        const auxTabs = tabs;
        auxTabs[indexOfTab].name = `${tabs[indexOfTab].name.replace(
            /\([0-9]*\)/g,
            ""
        )} (${wordCount})`;
        setTabs(auxTabs);
    }, [kwNetlinkingInput.value]);
    return (
        <>
            <div className="d-flex justify-content-between mb-2">
                <div>
                    <p className="form-label">
                        {formatMessage({ id: "common.field.netlinkingKeywords" })} <br />
                    </p>
                    {formatMessage(
                        { id: "common.field.netlinkingMainThematicMaxWords" },
                        {
                            mainThematic: planning.moneySite.thematic.name,
                            maxKeywords:
                                ((planning.moneySite.content?.netlinking || 0) * planning.months) /
                                2,
                        }
                    )}{" "}
                    <br />
                    {formatMessage(
                        { id: "common.field.netlinkingOtherThematicMaxWords" },
                        {
                            maxKeywords:
                                ((planning.moneySite.content?.netlinking || 0) * planning.months) /
                                2,
                        }
                    )}
                </div>
                {tabs.length > 0 && (
                    <Button style={{ width: "114px", height: "44px" }} onClick={handleModal}>
                        {formatMessage({ id: "common.action.showRdModal" })}
                    </Button>
                )}
            </div>
            <DynamicTabs
                tabs={tabs}
                seleted={seleted}
                onAdd={onAdd}
                onDelete={onDelete}
                onSelect={onSelect}
                addOptions={thematicsOptions}
            />
            {tabs.map((el, index) => (
                <Row hidden={el.index !== seleted.index} key={index}>
                    <Col>
                        <SimpleFormTextarea
                            cssClass={["bottom-border-radius"]}
                            name={`kwNetlinking.thematicId${el.index}`}
                            rows={20}
                        />
                    </Col>
                </Row>
            ))}
            <SimpleModal
                showModal={showModal}
                entityName={formatMessage({ id: "common.entity.rds" })}
                handleClose={handleModal}
                formId={""}
                buttonConfirmationAction={handleModal}
                buttonConfirmationLabel={formatMessage({ id: "common.action.close" })}
                modalProps={{ size: "xl" }}
            >
                <RDListByThematicIdContainer
                    moneySiteId={planning.moneySite.id}
                    thematicId={tabs.map((el) => el.index)}
                />
            </SimpleModal>
        </>
    );
};

export default NetlinkingOrderForm;
